import React, { useEffect, useRef } from 'react';

const MatrixBackground = ({ opacity = 0.15 }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    
    // Set canvas size
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Matrix characters - mix of code symbols
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%^&*(){}[]<>/\\|~`+=アイウエオカキクケコサシスセソ'.split('');
    const fontSize = 16;
    const columns = canvas.width / fontSize;
    const drops = [];
    const speeds = [];

    // Initialize drops with varying speeds - fewer columns for balance
    for (let i = 0; i < columns; i++) {
      // Only show 40% of possible columns
      if (Math.random() > 0.6) {
        drops[i] = Math.random() * -50;
        speeds[i] = 0.5 + Math.random() * 0.5;
      } else {
        drops[i] = -9999; // Hide this column
        speeds[i] = 0;
      }
    }

    // Draw function
    const draw = () => {
      // Semi-transparent black for fade trail
      ctx.fillStyle = 'rgba(0, 0, 0, 0.05)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Draw characters
      for (let i = 0; i < drops.length; i++) {
        if (speeds[i] === 0) continue; // Skip hidden columns
        
        const text = chars[Math.floor(Math.random() * chars.length)];
        const x = i * fontSize;
        const y = drops[i] * fontSize;

        // Brighter tip
        ctx.fillStyle = 'rgba(74, 222, 128, 0.8)';
        ctx.font = `bold ${fontSize}px monospace`;
        ctx.fillText(text, x, y);

        // Shorter, lighter trail
        for (let j = 1; j < 5; j++) {
          const trailY = y - fontSize * j;
          if (trailY > 0) {
            const alpha = (5 - j) / 5;
            ctx.fillStyle = `rgba(37, 99, 235, ${alpha * 0.2})`;
            ctx.font = `${fontSize}px monospace`;
            ctx.fillText(chars[Math.floor(Math.random() * chars.length)], x, trailY);
          }
        }

        // Reset drop to top
        if (y > canvas.height && Math.random() > 0.92) {
          drops[i] = 0;
        }
        drops[i] += speeds[i];
      }
    };

    // Faster animation loop
    const interval = setInterval(draw, 30);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed top-0 left-0 w-full h-full pointer-events-none z-50"
      style={{ opacity, mixBlendMode: 'screen' }}
    />
  );
};

export default MatrixBackground;
